module.exports = __webpack_public_path__ + "static/media/uspcasw.fffd6505.png";